import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-three-lesson-four-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitThreeLessonFourGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 3, Lesson 4 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 4: Job Shadowing";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
